<template>
  <div
    @mouseenter="focusCart"
    :style="{
      top:
        $route.name == 'store'
          ? this.getFirstValidRedemptionRule
            ? '60px'
            : '130px'
          : '20px',
      position: 'sticky',
      'border-top': `${isRolldStore() ? '1px solid #d9d9d9' : 'unset'}`,
      'z-index': '1',
    }"
  >
    <div :class="isRolldStore() ? '' : 'bg-white'">
      <div>
        <div v-if="cartItems.length > 0" class="container-fluid p-0">
          <div class="row shopping-cart-clearall">
            <div class="col-md-6">
              <h3 :class="{ 'text-gray': !isRolldStore() }">
                {{ $t("message.order") }}
              </h3>
            </div>
            <div class="btn col-md-6 text-right">
              <a
                @click="clearAllOrders()"
                :style="desktopStyles.LinkColorTxt"
                >{{ $t("message.clearAll") }}</a
              >
            </div>
          </div>
          <hr v-if="!isRolldStore()" class="m-0" />
        </div>
        <div class="container">
          <div
            class="row cart-items wholeOrderDiscount"
            v-if="wholeOrderDiscount && wholeOrderDiscountMessage"
          >
            <div :style="desktopStyles.successMsg" class="discount-container">
              {{ wholeOrderDiscountMessage }}
            </div>
          </div>
        </div>
        <div
          ref="cartWrapper"
          v-if="cartItems.length > 0"
          class="cart-items-wrapper"
        >
          <div class="container">
            <div v-if="showSharedCart && getSharedCart">
              <div v-for="(name, index) in getPeople" :key="index">
                <b style="font-size: larger; color: blue"
                  >{{ name === getUser ? "My Order" : `${name}'s Order` }}
                </b>
                <div
                  v-for="(item, idx) in getSharedCart[name].products"
                  :key="idx"
                >
                  <cart-item
                    :cart-item="item"
                    :removeButton="name === getUser"
                  />
                </div>
              </div>
            </div>
            <template v-else v-for="(item, index) in cartItems">
              <cart-item :cart-item="item" :key="index" :index="index" />
            </template>
          </div>

          <hr v-if="cartItems.length > 0" class="mb-0" />
        </div>
        <div
          class="container price-container mt-1"
          v-show="cartItems.length > 0"
        >
          <div class="row">
            <div class="col-sm-12 cart-totals">
              <div class="cart-subtotal-label">
                {{ $t("message.subtotal") }}
                {{ $t("message.exclude", { taxLabel }) }}
                <small class="fw-600"
                  >({{ cartLength }} {{ $t("message.items") }})</small
                >
              </div>
              <div class="cart-subtotal-cost">
                {{ subtotalPrice | formatMoney(currencySign) }}
              </div>
            </div>
          </div>
          <div v-if="showDelivery" class="row">
            <div class="col-sm-12 cart-totals">
              <div class="cart-subtotal-label">
                {{ $t("message.delivery") }}
              </div>
              <div class="cart-subtotal-cost">
                {{ deliveryFee | formatMoney(currencySign) }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 cart-totals">
              <div class="cart-subtotal-label">{{ taxLabel }}</div>
              <div class="cart-subtotal-cost">
                {{ totalGst | formatMoney(currencySign) }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 cart-totals">
              <div class="cart-subtotal-label">
                {{ $t("message.discount") }}
              </div>
              <div class="cart-subtotal-cost">
                {{ totalDiscount | formatMoney(currencySign) }}
              </div>
            </div>
          </div>
          <div v-if="getSurchargeBankAmount" class="row">
            <div class="col-sm-12 cart-totals">
              <div class="cart-subtotal-label">
                {{ $t("message.bankSurcharge") }}
              </div>
              <div class="cart-subtotal-cost">
                {{ getSurchargeBankAmount | formatMoney(currencySign) }}
              </div>
            </div>
          </div>
          <div v-if="getSurchareHolidayName" class="row">
            <div class="col-sm-12 cart-totals">
              <div class="cart-subtotal-label">
                {{ getSurchareHolidayName }}
              </div>
              <div class="cart-subtotal-cost">
                {{ getSurchargeHolidayAmount | formatMoney(currencySign) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr
        v-show="
          cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'
        "
      />
      <div v-if="showRedemptionButton" class="container">
        <div class="row pt-4">
          <div @click="addReedemption()" class="col-sm-12 checkout">
            <a class="btn redeem-btn btn-lg btn-block mb-2"
              >{{ RedemptionButtonText }}
            </a>
          </div>
        </div>
      </div>
      <div
        class="container"
        v-show="
          cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'
        "
      >
        <div class="row">
          <CouponComponent
            ref="couponComponent"
            :className="'cart-totals'"
          ></CouponComponent>
        </div>
      </div>
      <hr
        v-show="
          cartItems.length > 0 &&
          cartValue > 0 &&
          $route.name == 'checkout' &&
          !isRolldStore()
        "
      />
      <div class="container" style="padding-top: 13px">
        <div class="row">
          <div class="col-sm-12 cart-totals" :class="{ 'pb-4': hidePayButton }">
            <div class="total">{{ totalLabel }}</div>
            <div class="cost has-point">
              <span
                :class="{ 'px-2': (storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints) || enableStamps }"
                >{{ totalPrice | formatMoney(currencySign) }}</span
              >
              <span
                class="points text-success"
                v-if="getPoints && ((storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints) || enableStamps)"
                >({{ Math.floor(getPoints) | formatNumber }}
                {{ loyaltyUnit(Math.floor(getPoints)) }})</span
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="!hidePayButton" class="container">
        <div class="row">
          <div class="col-sm-12 checkout">
            <button
              v-if="!orderMode"
              @click="wastageReport ? showWastageAlert() : navigateToCheckout()"
              :disabled="cartItems.length === 0 || menuUnAvailable === true"
              class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
              :style="getCheckoutBtnStyles()"
            >
              {{
                menuUnAvailable
                  ? $t("message.storeClosed")
                  : $t("message.checkout")
              }}
            </button>
            <div
              v-show="menuUnAvailable && store.ClosingStoreMessage"
              class="pt-1"
              v-html="store.ClosingStoreMessage"
            />
            <div
              v-show="menuUnAvailable && !store.ClosingStoreMessage"
              class="pt-1"
            >
              {{ $t("message.CurrentlyNotTakingOnlineOrders") }}
            </div>
            <div
              v-show="!exceedMinPurchase && orderMode && !menuUnAvailable"
              class="color-red pt-1 text-center fs-90"
            >
              {{ $t("message.minimumPurchaseIs") }}
              {{ minPurchase | formatMoney(currencySign) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderMode" class="m-4">
      <button
        type="button"
        class="btn btn-block p-2 continue-order-btn"
        @click="continueOrder"
      >
        {{ $t("message.continueOrdering") }}
      </button>
    </div>
    <poweredby v-if="!isBranded()" />

    <modal
      ref="redemptionModal"
      v-if="showRedemption"
      full-header
      @close="closeModal"
      hide-footer
    >
      <template slot="body">
        <div
          style="
            height: calc(100vh - 100px);
            overflow-y: auto;
            margin-bottom: 50px;
          "
        >
          <Modifiers
            @canceled="closeModal"
            :product="selectedReedemption.product"
            :modifiers="selectedReedemption.modifiers"
            :product-id="selectedReedemption.productId"
            :price-trigger="getFirstValidRedemptionRule"
            @updated="selectRollIntoModiefiers"
            :is-submodifier="true"
            :has-confirm-button="true"
            is-redeem
          />
        </div>
      </template>
    </modal>

    <modal
      ref="privacyModal"
      v-if="showPrivacyModal"
      full-header
      @close="closePrivacyPolicyModal"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">
              {{ $t("message.termsAndConditions") }}
            </h2>
          </div>
          <p
            class="py-4 terms-and-conditions ios-scroll"
            v-html="currentStoreDoc.TermsAndConditions"
          ></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index: 2">
          <button
            class="privacy-btn pull-right"
            :style="buttonStyles"
            data-dismiss="modal"
            type="button"
            @click="closePrivacyPolicyModal()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>

    <modal
      ref="mobileOtpModal"
      v-if="showMobileOtpModal"
      :canBeDismissed="false"
      full-header
      :hideFooter="true"
    >
      <template slot="body">
        <checkout-otp
          @closeMobileOtpModal="onMobileOtpClose"
          @checkout="closeModalMobileAndCheckout"
        />
      </template>
    </modal>
    <paylater-alert
      :type="3"
      v-if="wastageAlertEnabled"
      @confirmed="navigateToCheckout()"
    ></paylater-alert>
    <block-time-alert
      v-if="blockTimeAlertEnabled"
      :remainingTime="remainingTime"
      :hideBlockModel="hideBlockModel"
    >
    </block-time-alert>
  </div>
</template>

<script>
import CartItem from "./CartItem";
import poweredby from "../../shared/poweredby";
import CouponComponent from "./CouponComponent";
import modal from "../../modal";
import shared from "../../../sharedscripts/shop/shopping-cart/ShoppingCart.js";
import Modifiers from "../products/Modifiers.vue";
import { mapGetters } from "vuex";
import CheckoutOtp from "@/components/shared/checkoutOtp";
import paylaterAlert from "../../shared/paylaterAlert.vue";
import blockTimeAlert from '../../shared/blockTimeAlert';

export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    poweredby,
    CouponComponent,
    modal,
    Modifiers,
    CheckoutOtp,
    paylaterAlert,
    blockTimeAlert,
  },
  props: {
    isFromHomePage: {
      type: Boolean,
      default: false,
    },
    orderMode: {
      type: Boolean,
      default: false,
    },
    proccessing: {
      type: Boolean,
      default: false,
    },
    orderType: {
      type: Number,
      default: null,
    },
    hidePayButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IsInOperationMessage: null,
      store: {},
      dpTimeIsSet: true,
      timerId: null,
      minPurchase: 0,
      selectedReedemption: null,
      showRedemption: false,
      showPrivacyModal: false,
      targetElement: {},
      showMobileOtpModal: false,
      wastageAlertEnabled: false,
      blockTimeAlertEnabled: false,
      remainingTime: { minutes: 0, seconds: 0 },
    };
  },
  created() {
    this.store = this.selectedCompany;
    this.validateCardAndRules();
  },
  mounted() {
    this.$root.$emit("settopmenuFromHomePage", this.isFromHomePage);
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "getSelectedMenuType",
      "getSharedCart",
      "showSharedCart",
      "getUser",
      "getPeople",
      "totalGst"
    ]),

    totalDiscount() {
      const totalValue = this.cartValue + this.deliveryFee;
      if (this.discount > totalValue) {
        return totalValue;
      }

      return this.discount;
    },
  },
  watch: {
    selectedCompany(newValue) {
      this.store = newValue;
      this.validateCardAndRules();
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    },
    cartItems: {
      handler: function (newValue) {
        this.fixRedemptionQuantity(newValue);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...shared.methods,
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    },
    getCheckoutBtnStyles() {
      var styles = [];
      styles.push(this.desktopStyles.btn);
      if (this.isRolldStore()) {
        styles.push({ "background-color": "#ff0619" });
        styles.push({ "border-radius": "100px" });
      }
      return styles;
    },
    // close mobile otp modal
    async closeModalMobileAndCheckout() {
      // pass isAuthorized flag if otp flow successful
      this.showMobileOtpModal = false;
      await this.redirectToCheckOut();
    },
  },
};
</script>
